<kendo-dialog tid="img_preview" *ngIf="open" class="container">
    <img [src]="src" />
</kendo-dialog>